/* @ngInject */
const ask = (
  utils,
  valueHandler,
  wagonRequest,
  wagonLocal,
  wagonFormat,
  wagonData,
  toaster,
  wagonLabels,
  editFieldModal,
  editFieldsModal,
  editOwnerModal,
  editOwnersModal,
  editDispositionModal,
  editDispositionsModal,
  parkIdNewModal,
  matcher,
  wagonUtils,
) => {
  const self = {}

  self.delete = async (_id, _back = false) => {
    if (valueHandler.isId(_id.id)) { _id = _id.id }

    if (toaster.confirm(wagonLabels.ask.delete)) {
      try {
        const response = await wagonRequest.delete(_id)
        toaster.message(response.message)

        utils.removeFromArray(wagonData.myWagons, response.id)
        utils.removeFromArray(wagonData.mySearchedWagons, response.id)
        if (_back) {
          utils.$back()
        }
      } catch (error) {
        toaster.error(error)
      }
    }
  }

  self.update = async (_wagon, _back = false) => {
    const wagon = utils.copy(_wagon)
    wagon.id = wagonLocal.getCurrentId()

    try {
      const response = await wagonRequest.update(wagonFormat.server(wagon))
      toaster.message(response.message)
      utils.updateFromArray(wagonData.myWagons, response.wagon)
      if (_back) {
        utils.$back()
      }
    } catch (error) {
      toaster.error(error)
    }
  }

  self.scrap = async (_wagon) => {
    const id = _wagon.id
    const scrapped = _wagon.scrapped
    let message

    if (scrapped) { message = wagonLabels.ask.disableScrapped }
    else { message = wagonLabels.ask.enableScrapped }

    if (toaster.confirm(message)) {
      try {
        const message = await wagonRequest.scrap(id, scrapped)
        toaster.message(message)
        _wagon.scrapped = !scrapped
      } catch (error) {
        toaster.error(error)
      }
    }
  }

  self.renameWagon = async (_wagon) => {
    try {
      const modal = await parkIdNewModal.open(_wagon)
      const result = await modal.result
      if (result) {
        if (result === 'yes') {
          await wagonRequest.renameWagon(_wagon.id)
        }
        const wagon = await wagonRequest.getById(_wagon.id)
        const id = wagonData.myWagon.id
        wagonData.myWagon = wagonFormat.user(wagon)
        wagonData.myWagon.id = id
        utils.updateFromArray(wagonData.myWagons, wagon)
      }
    } catch (error) {
      toaster.message(`Le wagon ${wagonUtils.idToString(_wagon.id)} est encore garé sur une voie`, 'orange')
      wagonData.myWagon.id = _wagon.id.slice(0, 7)
    }
  }

  self.editField = (_wagon, _fieldName) => {
    return editFieldModal.open(_wagon, _fieldName)
  }

  self.editOwner = (_wagon, _fieldName) => {
    return editOwnerModal.open(_wagon, _fieldName)
  }

  self.editOwners = (_wagon, _fieldName, _data, _filteredData) => {
    return editOwnersModal.open(_wagon, _fieldName, _data, _filteredData)
  }

  self.editDisposition = (_wagon, _ref, _wagons) => {
    return editDispositionModal.open(_wagon, _wagons)
  }

  self.editDispositions = (_fieldName, _fieldLabel, _wagons) => {
    return editDispositionsModal.open(_fieldName, _fieldLabel, _wagons)
  }

  self.editFields = (_fieldName, _fieldLabel, _data, _filteredData) => {
    return editFieldsModal.open(_fieldName, _fieldLabel, _data, _filteredData)
  }

  self.searchField = async (_fieldName, _fieldValue, _data) => {
    console.log('searchField', _fieldName, _fieldValue, _data)

    if (valueHandler.isEmpty(_fieldValue)) {
      return toaster.message('Le champ est vide', 'orange')
    }

    let data
    if (matcher.containDate(_fieldName)) {
      _fieldValue = utils.date.stringToServer(utils.date.timestampToString(_fieldValue))

      data = {
        [`${_fieldName}Begin`]: _fieldValue,
        [`${_fieldName}End`]: _fieldValue,
      }
    } else {
      data = {
        [_fieldName]: _fieldValue,
        [`${_fieldName}Operator`]: '!',
      }
    }

    try {
      const response = await wagonRequest.getBySearch(data)
      if (response.wagons.length > 100) {
        if (!toaster.confirm(`${response.wagons.length} wagons trouvés. Êtes-vous sur de vouloir les afficher ?`)) {
          return
        }
      }

      utils.emptyArray(_data)

      response.wagons.forEach((wagon) => {
        utils.addFromArray(_data, wagon)
      })

      toaster.message(response.message, response.color)
    } catch (error) {
      toaster.error(error)
    }
  }

  return self
}

export default ask



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/services/ask.service.js